// MessageCount.tsx
import { Badge } from '@components'
import { api } from '@here/api'
import { useQuery } from '@tanstack/solid-query'
import { Star } from 'lucide-solid'
import { Show } from 'solid-js'
import { css } from 'styled-system/css'

async function fetchCommanderScore(channelId: string): Promise<number | null> {
	const { data: commanders, error: commandersErr } = await api()
		.from('profile_private')
		.select('id')
		.eq('role', 'commander')

	if (commandersErr) throw commandersErr

	const commanderIds = (commanders ?? []).map((r) => r.id)
	if (!commanderIds.length) {
		// nothing to fetch
		return null
	}

	const { data, error } = await api()
		.from('taken_setups')
		.select('score', { head: false })
		.eq('setup_id', channelId)
		.not('user_id', 'in', `(${commanderIds.join(',')})`)

	return data && data.reduce((s, r) => s + (r.score ?? 0), 0) / data.length
}

export const CommunityScore = (props: { channelId?: string; setup: any }) => {
	const q = useQuery(() => ({
		queryKey: ['community-score-count', props.channelId],
		queryFn: () => fetchCommanderScore(props.channelId!),
		enabled: !!props.channelId,
		staleTime: 30 * 60 * 1000, // 30m cache freshness
		gcTime: 30 * 60 * 1000, // 30m cache retention
		retry: 1,
		placeholderData: 0,
	}))

	return (
		<Show when={(q?.data && q?.data > 0) || props.setup.community_score}>
			<Badge
				size="sm"
				variant="solid"
				justifyContent="center"
        color='white'
        bg="neutralSubtle"
			>
				<Star fill='white' />
				{q.data || props.setup.community_score}
			</Badge>
		</Show>
	)
}
